import React from "react";
import { Link } from "react-router-dom";
import "./Nopage.css";

const Nopage = () => {
  return (
    <section className="noPage">
      <div id="notfound">
        <div className="notfound-bg">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className="notfound">
          <div className="notfound-404">
            <h1>404</h1>
          </div>
          <h2>Page Not Found</h2>
          <p>
            The page you are looking for might have been removed had its name
            changed or is temporarily unavailable.
          </p>
          <Link to="https://cohesiveminds.cuet.testknock.com/">Homepage</Link>
          <div className="notfound-social d-none">
            <a href="https://www.facebook.com//profile.php?id=61569671270471">
              <i className="fa fa-facebook"></i>
            </a>
            <a href="https://www.youtube.com//@cohesiveminds6974">
              <i className="fa fa-youtube"></i>
            </a>
            <a href="https://www.instagram.com/cohesiveminds/">
              <i className="fa fa-instagram"></i>
            </a>
            <a href="https://www.linkedin.com/company/99324850">
              <i className="fa fa-linkedin"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Nopage;